"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBBMyDeviceComponent = void 0;
const account_service_1 = require("../../shared/services/account.service");
const router_1 = require("@angular/router");
const _ = require("underscore");
class CSBBMyDeviceComponent {
    constructor(router, accountService) {
        this.router = router;
        this.accountService = accountService;
    }
    ngOnInit() {
        this.upgradeContent = 'Upgrade This Device';
        this.getAccountDetails();
    }
    getAccountDetails() {
        this.loader = true;
        this.loading = true;
        this.accountService.getDeviceListlInformation().subscribe((deviceInfo) => {
            this.loader = false;
            this.loading = false;
            this.subscriptions = deviceInfo.deviceDetailList;
            this.tempSubscriptions = _.clone(this.subscriptions);
            const that = this;
            _.each(that.subscriptions, function (key, value) {
                that.tempSubscriptions[value] = _.pick(that.subscriptions[value], 'subscriberBusinessName', 'mobileNumber', 'esnMeid', 'subscriptionId');
            });
        }, (err) => {
            this.error = err;
            this.loading = false;
        });
    }
    getSubDetails(event) {
        this.subId = event.subscriptionId;
        this.isLineDetail = true;
        this.subDetails = _.findWhere(this.subscriptions, { 'subscriptionId': this.subId });
    }
    showDetails(subscriptionId) {
        this.router.navigate(['/business/device'], { queryParams: { subId: subscriptionId } });
    }
}
exports.CSBBMyDeviceComponent = CSBBMyDeviceComponent;
//# sourceMappingURL=bbmydevices.component.js.map